<p-confirmDialog draggable="false" />
<div class="page-header ">
  <div class="flex  xl:align-items-center flex-wrap xl:flex-nowrap gap-3 w-full">
    <div class="flex-grow-1">
      <!-- <app-primeng-breadcrumb></app-primeng-breadcrumb> -->
    </div>
    <div class="right-container flex flex-wrap xl:flex-nowrap gap-3 justify-end">
      <p-button label="Add Organization" (onClick)="addCustomerPage()" [outlined]="false" severity="primary">
        <i-tabler class="ti-normal ti-lg" name="plus"></i-tabler>
      </p-button>
    </div>
  </div>
</div>
<ng-container *ngIf="loading()">
</ng-container>

<div class="page-content mt-2">
  <app-skeleton *ngIf="loading()" id="table-items" [columns]="tableConfig" [paginator]="true"></app-skeleton>
  <ng-container *ngIf="!loading()">
    <app-primeng-table [tableData]="tableData" [columns]="tableConfig" [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true" [rows]="10" [responsiveLayout]="'scroll'" [styleClass]="'p-datatable-gridlines'"
      [customTemplates]="{'action': action, 'status': status}">
    </app-primeng-table>
    <ng-template #action let-rowData="rowData" let-rowIndex="rowIndex">
      <td class="flex">
        <p-button size="small" pTooltip="Edit" (onClick)="handleOptionClick(rowData,'Edit')" [text]="true"
          [raised]="false" severity="secondary">
          <i-tabler class="ti-normal ti-lg" name="edit"></i-tabler>
        </p-button>
        <p-button size="small" pTooltip="View" (onClick)="handleOptionClick(rowData,'View')" [text]="true"
          [raised]="false" severity="secondary">
          <i-tabler class="ti-normal ti-lg" name="eye"></i-tabler>
        </p-button>
        <p-button size="small" pTooltip="Delete" (onClick)="handleOptionClick(rowData,'Delete')" [text]="true"
          [raised]="false" severity="secondary">
          <i-tabler class="ti-normal ti-lg" name="trash"></i-tabler>
        </p-button>
      </td>
    </ng-template>
    <ng-template #status let-rowData="rowData" let-index="index">
      <td>
        <span class="font-weight-bold text-success">{{rowData?.status}}</span>
      </td>
    </ng-template>
  </ng-container>
</div>
<p-toast />